"use client"

import { useToast } from "../../hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "../../components/ui/toast"

export function Toaster({variant}: {variant?: "default" | "destructive" | "success" | "warning" | "info"}) {
  const { toasts } = useToast()

  return (
    <ToastProvider data-testid="Toaster-provider">
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <div key={id} data-testid={`Toaster-item-wrapper-${id}`}>
            
            <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[1199] pointer-events-auto" data-testid="Toaster-backdrop" />
            
            {/* Toast Modal */}
            <Toast variant={variant} {...props} data-testid={`Toaster-toast-${id}`}>
              <div className="w-full text-center" data-testid="Toaster-content-wrap">
                {title && <ToastTitle data-testid="Toaster-title">{title}</ToastTitle>}
                {description && (
                  <ToastDescription data-testid="Toaster-description">{description}</ToastDescription>
                )}
              </div>
              {action}
              <ToastClose data-testid="Toaster-close-btn" />
            </Toast>
          </div>
        )
      })}
      <ToastViewport data-testid="Toaster-viewport" />
    </ToastProvider>
  )
}